import Grid from '@mui/material/Grid'

import YearInput from 'components/Reporting/Overview/FilterBuilder/Filters/YearsOfBirth/TextBox/YearInput'
import FromAndToInput from 'components/Reporting/Overview/FilterBuilder/Filters/YearsOfBirth/TextBox/FromAndToInput'
import YOBFilterCategorySelection from 'components/Reporting/Overview/FilterBuilder/Filters/YearsOfBirth/TextBox/CategorySelection'
import {
  YearFilterValue,
  YearFilterError,
  HandleYearFilterSelectionType,
  HandleYearEntryType,
} from 'components/Reporting/Overview/FilterBuilder/Filters/YearsOfBirth/Types'

interface propsTypes {
  YearOfBirthFilterOptions?: string[]
  handleYearFilterSelection: HandleYearFilterSelectionType
  yearFilterValue: YearFilterValue
  yearFilterError: YearFilterError
  handleYearEntry: HandleYearEntryType
}

const YOBFilterDialogContent = (props: propsTypes) => {
  const {
    YearOfBirthFilterOptions,
    handleYearFilterSelection,
    yearFilterValue,
    yearFilterError,
    handleYearEntry,
  } = props

  const yearValues = { yearFilterValue, yearFilterError, handleYearEntry }
  return (
    <Grid container rowSpacing={3} columnSpacing={3}>
      <YOBFilterCategorySelection
        {...{
          yearFilterValue,
          YearOfBirthFilterOptions,
          handleYearFilterSelection,
        }}
      />
      {yearFilterValue.label === 'is_between' ? (
        <FromAndToInput {...yearValues} />
      ) : (
        <YearInput {...yearValues} />
      )}
    </Grid>
  )
}
export default YOBFilterDialogContent
